<template>
  <div>
    <v-card>
      <v-card-title class="text-h5">
        <h2>{{ PageTitle }}</h2>
      </v-card-title>

      <v-card-subtitle class="text-h5">
        <h4>{{ PageDescription }}</h4>
      </v-card-subtitle>

      <v-card-text>
        <v-container>
          <v-row wrap>
            <v-col align="center" cols="12" md="12">
              <v-btn
                large
                @click.prevent="$router.push('/users/password-reset')"
                color="success"
                elevation="30"
                shaped
                class="font-size-h6 mr-3 my-3 white--text"
                >&nbsp; Back &nbsp;
              </v-btn>
              <v-btn
                large
                @click.prevent="fetchBlockUsers"
                color="#a4c639"
                elevation="30"
                shaped
                class="font-size-h6 mr-3 my-3 white--text"
                >&nbsp; Refresh &nbsp;
              </v-btn>
              <v-btn
                large
                @click.prevent="openBlockUserDialog"
                color="#B01455"
                elevation="30"
                shaped
                class="font-size-h6 mr-3 my-3 white--text"
                >&nbsp; Block User &nbsp;
              </v-btn>
            </v-col>
          </v-row>

          <v-container class="py-0">
            <v-row wrap>
              <v-col align="center" cols="12" md="12">
                <div
                  class="d-flex justify-content-center mb-3"
                  v-if="ProgessStart == 1"
                >
                  <b-spinner
                    variant="primary"
                    type="grow"
                    label="We are fetching details, please wait..."
                  ></b-spinner>
                </div>
              </v-col>
            </v-row>
          </v-container>

          <v-container class="py-0" v-if="tableData1.length > 0">
            <v-row wrap>
              <v-col align="center" cols="12" md="12">
                <h3 class="red--text">
                  {{ tableData1.length }} records found.
                </h3>
              </v-col>
            </v-row>
            <br />
            <v-row wrap>
              <v-col align="center" cols="12" md="12">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
                <br />
                <v-data-table
                  class="elevation-1"
                  v-model="selected1"
                  :search="search"
                  :item-key="tableOptions1.ItemKey"
                  :single-select="tableOptions1.SingleSelectFlag"
                  :show-select="false"
                  :headers="tableColumns1"
                  :items="tableData1"
                  :items-per-page="tableOptions1.ItemsPerPage"
                  :footer-props="tableOptions1.FooterProps"
                >
                  <template v-slot:item.MemberName="{ item }">
                    <div>
                      <span
                        >{{ item.MemberName }} ({{ item.MembershipId }})</span
                      >
                    </div>
                  </template>

                  <template v-slot:item.Contact="{ item }">
                    <div>
                      <span>{{ item.EmailId }}</span
                      ><br />
                      <span>{{ item.MobileNo }}</span>
                    </div>
                  </template>

                  <template v-slot:item.Description="{ item }">
                    <div
                      v-if="item.Description && item.Description.length > 0"
                      style="min-width: 350px; padding: 8px 0"
                    >
                      <div
                        v-for="(history, index) in item.Description"
                        :key="index"
                      >
                        <div
                          class="text-body-2"
                          style="white-space: normal; line-height: 1"
                          v-html="
                            history
                              .replace(/''/g, '')
                              .replace(/&quot;/g, '')
                              .replace(/\x22/g, '')
                          "
                        ></div>
                        <v-divider
                          v-if="index < item.Description.length - 1"
                          class="my-2"
                          style="opacity: 0.5; border-style: dashed"
                        ></v-divider>
                      </div>
                    </div>
                    <span v-else class="grey--text">NA</span>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          icon
                          size="25px"
                          color="success"
                          @click="openUnblockUserDialog(item)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-account-check
                        </v-icon>
                      </template>
                      <span> Unblock User </span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>

          <v-dialog
            v-model="blockDialog"
            persistent
            max-width="900px"
            style="margin-top: 60px"
          >
            <v-card class="rounded-xl elevation-3">
              <!-- Dialog Header -->
              <v-toolbar color="primary" dense dark elevation="0" class="px-2">
                <v-icon left>mdi-block-helper</v-icon>
                <v-toolbar-title class="font-weight-bold ml-2">
                  Block User
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="blockDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <!-- Dialog Content -->
              <v-card-text class="pa-6">
                <v-form ref="blockForm" v-model="validBlock" lazy-validation>
                  <v-col>
                    <v-text-field
                      v-model="blockMembershipId"
                      :rules="blockMembershipIdRules"
                      :error-messages="blockErrorMessage"
                      label="Membership ID"
                      required
                    ></v-text-field>
                    <v-btn
                      color="primary"
                      class="px-6 rounded-lg text-none white--text"
                      elevation="0"
                      :loading="searchLoading"
                      @click="searchMemberDetails"
                    >
                      Search
                    </v-btn>
                    <!-- member search results -->
                    <v-card
                      v-if="ResultFlag"
                      class="mt-4 pa-4 rounded-lg"
                      outlined
                      color="grey lighten-5"
                      elevation="0"
                    >
                      <div>
                        <h4 class="mb-2">Member Details</h4>
                      </div>
                      <v-divider class="mb-4"></v-divider>
                      <v-row>
                        <v-col md="4" sm="6" cols="12">
                          <span class="grey--text text-caption"
                            >Member Name</span
                          >
                          <h4 class="mt-1">
                            {{ Member.FirstName }} {{ Member.MiddleName }}
                            {{ Member.LastName }}
                          </h4>
                        </v-col>
                        <v-col md="4" sm="6" cols="12">
                          <span class="grey--text text-caption">Mobile No</span>
                          <h4 class="mt-1">
                            {{ Member.MobileNoTxt }}
                          </h4>
                        </v-col>
                        <v-col md="4" sm="6" cols="12">
                          <span class="grey--text text-caption">Email Id</span>
                          <h4 class="mt-1">
                            {{ Member.EmailIdTxt }}
                          </h4>
                        </v-col>
                        <v-col md="4" sm="6" cols="12">
                          <span class="grey--text text-caption">Zone Name</span>
                          <h4 class="mt-1">
                            {{ Member.ZoneName }}
                          </h4>
                        </v-col>
                        <v-col md="4" sm="6" cols="12">
                          <span class="grey--text text-caption">LO Name</span>
                          <h4 class="mt-1">
                            {{ Member.LomName }}
                          </h4>
                        </v-col>
                      </v-row>
                      <v-row class="mt-4">
                        <v-col cols="12">
                          <div class="d-flex align-center mb-4">
                            <v-avatar
                              color="rgba(21, 101, 192, 0.1)"
                              size="48"
                              class="mr-3"
                            >
                              <v-icon color="#1565C0"
                                >mdi-comment-text-outline</v-icon
                              >
                            </v-avatar>
                            <h3
                              class="font-weight-bold"
                              style="color: #263238; margin: 0"
                            >
                              Description
                            </h3>
                          </div>

                          <v-card
                            v-if="
                              Member.Description &&
                              Member.Description.length > 0
                            "
                            outlined
                            class="pa-4 mb-3"
                            style="
                              background-color: #f8f9fa;
                              border-radius: 12px;
                              border-left: 4px solid #1565c0;
                              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
                            "
                          >
                            <div
                              v-for="(history, index) in Member.Description"
                              :key="index"
                            >
                              <div
                                class="text-body-1"
                                style="color: #263238; padding: 4px 0"
                                v-html="history"
                              ></div>
                              <v-divider
                                v-if="index < Member.Description.length - 1"
                                class="my-2"
                                style="opacity: 0.6; border-style: dashed"
                              ></v-divider>
                            </div>
                          </v-card>

                          <h4 v-else class="grey--text pl-2">NA</h4>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-textarea
                      v-model="blockDescription"
                      :rules="blockDescriptionRules"
                      label="Reason for Block"
                      outlined
                      rows="4"
                      required
                    ></v-textarea>
                  </v-col>
                </v-form>
              </v-card-text>

              <!-- Dialog Footer -->
              <v-card-actions class="pa-4 bg-grey-lighten-4">
                <v-spacer></v-spacer>
                <v-btn
                  color="grey"
                  class="px-6 rounded-lg text-none white--text mr-2"
                  elevation="0"
                  @click="blockDialog = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="error"
                  class="px-6 rounded-lg text-none white--text"
                  elevation="0"
                  :disabled="!validBlock || !ResultFlag || !blockDescription"
                  :loading="blockLoading"
                  @click="blockMembers"
                >
                  Block
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Unblock User Dialog -->
          <v-dialog
            v-model="unblockDialog"
            persistent
            max-width="700px"
            style="margin-top: 60px"
          >
            <v-card class="rounded-xl elevation-3">
              <!-- Dialog Header -->
              <v-toolbar color="primary" dense dark elevation="0" class="px-2">
                <v-icon left>mdi-account-check</v-icon>
                <v-toolbar-title class="font-weight-bold ml-2">
                  Unblock User
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="unblockDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <!-- Dialog Content -->
              <v-card-text class="pa-6">
                <v-form
                  ref="unblockForm"
                  v-model="validUnblock"
                  lazy-validation
                >
                  <!-- Member Details Card -->
                  <v-card
                    v-if="unblockMember"
                    class="mt-2 mb-4 pa-4 rounded-lg"
                    outlined
                    color="grey lighten-5"
                    elevation="0"
                  >
                    <div>
                      <h4 class="mb-2">Member Details</h4>
                    </div>
                    <v-divider class="mb-4"></v-divider>
                    <v-row>
                      <v-col md="6" sm="6" cols="12">
                        <span class="grey--text text-caption">Member Name</span>
                        <h4 class="mt-1">{{ unblockMember.MemberName }}</h4>
                      </v-col>
                      <v-col md="6" sm="6" cols="12">
                        <span class="grey--text text-caption"
                          >Membership ID</span
                        >
                        <h4 class="mt-1">{{ unblockMember.MembershipId }}</h4>
                      </v-col>
                      <v-col md="6" sm="6" cols="12">
                        <span class="grey--text text-caption">Mobile No</span>
                        <h4 class="mt-1">
                          {{ unblockMember.MobileNo || "NA" }}
                        </h4>
                      </v-col>
                      <v-col md="6" sm="6" cols="12">
                        <span class="grey--text text-caption">Email ID</span>
                        <h4 class="mt-1">
                          {{ unblockMember.EmailId || "NA" }}
                        </h4>
                      </v-col>
                      <v-col md="6" sm="6" cols="12">
                        <span class="grey--text text-caption">Zone</span>
                        <h4 class="mt-1">{{ unblockMember.Zone || "NA" }}</h4>
                      </v-col>
                      <v-col md="6" sm="6" cols="12">
                        <span class="grey--text text-caption">LO Name</span>
                        <h4 class="mt-1">{{ unblockMember.LOName || "NA" }}</h4>
                      </v-col>
                    </v-row>
                    <v-row class="mt-4">
                      <v-col cols="12">
                        <div class="d-flex align-center mb-4">
                          <v-avatar
                            color="rgba(21, 101, 192, 0.1)"
                            size="48"
                            class="mr-3"
                          >
                            <v-icon color="#1565C0"
                              >mdi-comment-text-outline</v-icon
                            >
                          </v-avatar>
                          <h3
                            class="font-weight-bold"
                            style="color: #263238; margin: 0"
                          >
                            Description
                          </h3>
                        </div>

                        <v-card
                          v-if="
                            unblockMember.Description &&
                            unblockMember.Description.length > 0
                          "
                          outlined
                          class="pa-4 mb-3"
                          style="
                            background-color: #f8f9fa;
                            border-radius: 12px;
                            border-left: 4px solid #1565c0;
                            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
                          "
                        >
                          <div
                            v-for="(
                              history, index
                            ) in unblockMember.Description"
                            :key="index"
                          >
                            <div
                              class="text-body-1"
                              style="color: #263238; padding: 4px 0"
                              v-html="history"
                            ></div>
                            <v-divider
                              v-if="
                                index < unblockMember.Description.length - 1
                              "
                              class="my-2"
                              style="opacity: 0.6; border-style: dashed"
                            ></v-divider>
                          </div>
                        </v-card>

                        <h4 v-else class="grey--text pl-2">NA</h4>
                      </v-col>
                    </v-row>
                  </v-card>

                  <v-col class="px-0">
                    <v-textarea
                      v-model="unblockDescription"
                      :rules="unblockDescriptionRules"
                      label="Reason for Unblock"
                      outlined
                      rows="4"
                      required
                    ></v-textarea>
                  </v-col>
                </v-form>
              </v-card-text>

              <!-- Dialog Footer -->
              <v-card-actions class="pa-4">
                <v-spacer></v-spacer>
                <v-btn
                  color="grey"
                  class="px-6 rounded-lg text-none white--text mr-2"
                  elevation="0"
                  @click="unblockDialog = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="success"
                  class="px-6 rounded-lg text-none white--text"
                  elevation="0"
                  :disabled="!validUnblock || !unblockDescription"
                  :loading="unblockLoading"
                  @click="unblockMembers"
                >
                  <v-icon left>mdi-account-check</v-icon>
                  Unblock
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [common],
  data() {
    return {
      PageTitle: "Block Users List",
      PageDescription: "View and Unblock Blocked Users List",
      search: "",
      ProgessStart: 0,

      tableData1: [],
      tableOptions1: {},
      tableColumns1: [],
      selected1: [],

      blockDialog: false,
      validBlock: true,
      blockMembershipId: "",
      blockMembershipIdRules: [(v) => !!v || "Membership ID is required"],
      blockDescription: "",
      blockDescriptionRules: [(v) => !!v || "Description is required"],
      blockLoading: false,
      blockErrorMessage: "",

      searchLoading: false,
      ResultFlag: false,
      valid2: true,
      AdminFlag: false,
      Member: {},

      // Unblock dialog
      unblockDialog: false,
      validUnblock: true,
      unblockMember: null,
      unblockDescription: "",
      unblockDescriptionRules: [
        (v) => !!v || "Reason for unblocking is required",
      ],
      unblockLoading: false,
    };
  },
  mounted() {
    this.fetchBlockUsers();
  },
  computed: {
    searchMember() {
      return this.searchMemberDetails();
    },
    clearMemberDetails() {
      this.ResultFlag = false;
      this.Member = {};
      return this.blockMembershipId;
    },
  },
  watch: {
    blockMembershipId() {
      this.ResultFlag = false;
      this.Member = {};
      this.blockErrorMessage = "";
    },
  },

  methods: {
    fetchBlockUsers() {
      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      this.selected1 = [];
      this.tableData1 = [];

      // block_members_list API
      var add_url = server_url + "api/users/block-member-lists";
      var upload = {
        UserInterface: 1,
      };

      const thisIns = this;
      thisIns.ProgessStart = 1;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          thisIns.ProgessStart = 0;
          var output = response.data.output;
          var flag = response.data.flag;
          var table_content = response.data.records;

          if (flag == 1) {
            thisIns.tableColumns1 = table_content.TableHeader;
            thisIns.tableOptions1 = table_content.TableOptions;
            thisIns.tableData1 = table_content.TableData;
            thisIns.toast("success", output);
          } else {
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.ProgessStart = 0;
        });
    },

    openBlockUserDialog() {
      this.blockMembershipId = "";
      this.blockDescription = "";
      this.blockErrorMessage = "";
      this.ResultFlag = false;
      this.Member = {};
      this.blockDialog = true;
      this.$nextTick(() => {
        if (this.$refs.blockForm) {
          this.$refs.blockForm.resetValidation();
        }
      });
    },

    searchMemberDetails() {
      if (!this.blockMembershipId) {
        this.toast("error", "Membership ID is required.");
        return;
      }

      // Check if the user is already blocked or not
      const isAlreadyBlocked = this.tableData1.some(
        (user) =>
          user.MembershipId.toLowerCase() ===
          this.blockMembershipId.toLowerCase()
      );

      if (isAlreadyBlocked) {
        this.blockErrorMessage = "This user is already blocked.";
        this.ResultFlag = false;
        this.Member = {};
        return;
      }

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/users/show";
      var upload = {
        UserInterface: 1,
        Username: this.blockMembershipId,
      };

      this.searchLoading = true;
      this.ResultFlag = false;
      this.Member = {};
      const thisIns = this;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          thisIns.searchLoading = false;
          var output = response.data.output;
          var flag = response.data.flag;
          var records = response.data.records;

          if (flag == 1) {
            thisIns.Member = records;
            thisIns.AdminFlag = records.AdminFlag || false;
            thisIns.ResultFlag = true;
            thisIns.toast("success", output);
          } else {
            thisIns.ResultFlag = false;
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.searchLoading = false;
          thisIns.ResultFlag = false;
        });
    },

    blockMembers() {
      var validate = this.$refs.blockForm.validate();
      if (!validate) return;

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/users/block-members";
      var upload = {
        UserInterface: 1,
        MembershipId: this.blockMembershipId,
        Description: this.blockDescription,
      };

      this.blockLoading = true;
      const thisIns = this;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          thisIns.blockLoading = false;
          var output = response.data.output;
          var flag = response.data.flag;

          if (flag == 1) {
            thisIns.blockDialog = false;
            thisIns.toast("success", output);
            thisIns.fetchBlockUsers();
          } else {
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.blockLoading = false;
        });
    },
    openUnblockUserDialog(item) {
      this.unblockMember = item;
      this.unblockDescription = "";
      this.validUnblock = true;
      if (this.$refs.unblockForm) {
        this.$refs.unblockForm.resetValidation();
      }
      this.unblockDialog = true;
    },

    unblockMembers() {
      var validate = this.$refs.unblockForm.validate();
      if (!validate) return;

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/users/unblock-members";
      var upload = {
        UserInterface: 1,
        MembershipId: this.unblockMember.MembershipId,
        Description: this.unblockDescription,
      };

      this.unblockLoading = true;
      const thisIns = this;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          thisIns.unblockLoading = false;
          var output = response.data.output;
          var flag = response.data.flag;

          if (flag == 1) {
            thisIns.unblockDialog = false;
            thisIns.unblockMember = null;
            thisIns.unblockDescription = "";
            thisIns.toast("success", output);
            thisIns.fetchBlockUsers();
          } else {
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.unblockLoading = false;
        });
    },
  },
};
</script>

<style scoped>
::v-deep .v-data-table td {
  vertical-align: top;
  padding-top: 16px;
  padding-bottom: 16px;
}
::v-deep .v-data-table th {
  vertical-align: middle !important;
  white-space: nowrap !important;
}
::v-deep .v-data-table th .v-data-table-header__content {
  align-items: center !important;
}
</style>
